<template>
	<div class="slide-timeline-wrapper">
		<slide-time-line></slide-time-line>
	</div>
</template>

<script>
import SlideTimeLine from './timeLine/SlideTimeLine.vue';

export default {
	name: 'SlideTimeLineWrapper',
	components: { SlideTimeLine }
};
</script>

<style scoped>
.slide-timeline-wrapper {
	position: absolute;
	width: 100%;
	bottom: 36px;
	z-index: 1;
	background-color: #fff;
}
</style>
